import { Box, styled, Text } from '@ltvco/refresh-lib/theme';

// ─── Report card shared components ───────────────────────────────────────────

export const ReportCardContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 720,
  backgroundColor: theme.palette.background.paper,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 8,
}));

export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
});

export const HeaderLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

// ─── Teaser card shared components ───────────────────────────────────────────

export const TeaserItemContainer = styled('button')(({ theme }) => ({
  width: '100%',
  border: 0,
  padding: 0,
  margin: 0,
  background: 'transparent',
  textAlign: 'left',
  font: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const TeaserItemRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  padding: theme.spacing(1.5, 0),
}));

export const TeaserAvatar = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: theme.palette.button.light,
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const TeaserInfo = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const TeaserName = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  display: 'block',
  marginBottom: 4,
}));

export const TeaserDetailRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: 4,
  marginBottom: 2,
});

export const TeaserDetailLabel = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
}));

export const TeaserDetailValue = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ChevronButton = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: theme.palette.text.secondary,
  alignSelf: 'center',
}));
